import { defineMessages } from 'react-intl';
import { fieldNames } from './model';

export default defineMessages({
  title: {
    id: 'pages.contact.title',
    defaultMessage: 'Edit Feature',
  },
  success: {
    id: 'pages.contact.success',
    defaultMessage: 'Submitted Successfully',
  },
  [fieldNames.name]: {
    id: 'pages.contact.name',
    defaultMessage: 'Name',
  },
  [fieldNames.email]: {
    id: 'pages.contact.email',
    defaultMessage: 'Email',
  },
  [fieldNames.message]: {
    id: 'pages.contact.message',
    defaultMessage: 'Message',
  },
  submitButton: {
    id: 'pages.contact.submitButton',
    defaultMessage: 'Send',
  },
});



// WEBPACK FOOTER //
// ./src/ui/graphql/ContactMessage/messages.js